import logo from './logo.svg';
import './App.css';
import HeroSection from './screens/FirstScreen';
import SecondScreen from './screens/SecondScreen';
import AboutMe from './components/me/Me';
import WorkflowSteps from './components/step/Steps';
import ForWhom from './components/fit/WhoFits';
import WorkflowTimeline from './components/step/Steps';
import FloatingButton from './components/FloatButton/FloatButton';
import ForthScreen from './screens/ForthScreen';
import ByMe from './components/ByMe/ByMe';
import ThirdScreen from './screens/ThirdScreen';
import WhoDoesList from './components/time/Time';
import FifthScreen from './screens/FifthScreen';

function App() {
  return <>
  <HeroSection/>
  <SecondScreen/>
  <AboutMe/>
  <ThirdScreen/>
  <WorkflowTimeline/>
  {/* <ForWhom/> */}
  <FifthScreen/>
  <ForthScreen/>
  <FloatingButton/>
  <ByMe/>
  {/* <WorkflowSteps/> */}
  </>
}

export default App;
